angular
  .module('inhouseNoticeList')
  .component('inhouseNoticeList', {
    template: require('./inhouse-notice-list.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function inhouseNoticeViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'notices';
        $rootScope.menu = 'inhouseNoticeList';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.total_count = 0;
        this.query = '';
        $resource(`${APIURL}/admin/inhouseNotice`).get({ q: this.query }).$promise
          .then((data) => {
            this.notices = data.notices;
            this.total_count = data.count;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/inhouseNotice`).get({ page: page - 1, q: this.query },
            (data) => {
              this.notices = data.notices;
              this.total_count = data.count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.view = (notice) => {
          $rootScope.inhouseNoticeId = notice.ID;
          $location.path('/inhouse/notice/view/');
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-list/inhouse-notice-list.component.js